import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesStatesListComponent } from './cases-states-list/cases-states-list.component';
import { CasesStatesDetailComponent } from './cases-states-detail/cases-states-detail.component';

const routes: Routes = [
    {
        path: 'casesStates',
        children: [
            { path: '', component: CasesStatesListComponent }
        ]
    },
    {
        path: 'casesStates/:id',
        children: [
            { path: '', component: CasesStatesDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CasesStatesRoutingModule { }
